import { useTranslation } from 'react-i18next';

import type {
  TYPE_DESIRED_COLOR_OPTIONS,
  TYPE_DESIRED_STYLE_OPTIONS,
  TYPE_MATERIAL_OPTIONS,
  TYPE_ROOM_MODE_OPTIONS,
  TYPE_ROOM_TYPE_OPTIONS,
} from '../../constants/style-settings';
import { CollapsableCard } from '../collapsable-card';
import { DesiredColorSettings } from './desired-color-settings';
import { DesiredStyleSettings } from './desired-style-settings';
import { MaterialSettings } from './materials-settings';
import { RoomModeSettings } from './room-mode-settings';
import { RoomTypeSettings } from './room-type-settings';

export type StyleSettings = {
  roomMode?: TYPE_ROOM_MODE_OPTIONS;
  roomType?: TYPE_ROOM_TYPE_OPTIONS;
  desiredStyle?: TYPE_DESIRED_STYLE_OPTIONS;
  desiredColor?: TYPE_DESIRED_COLOR_OPTIONS[];
  materials?: TYPE_MATERIAL_OPTIONS[];
};

export const StyleSettings = () => {
  const { t } = useTranslation();

  return (
    <CollapsableCard title={t('styleSettings')}>
      <div className="flex flex-col gap-2">
        <RoomModeSettings />
        <RoomTypeSettings />
        <DesiredStyleSettings />
        <DesiredColorSettings />
        <MaterialSettings />
      </div>
    </CollapsableCard>
  );
};
